import React from "react";

export const SelectionContext = React.createContext({
  selections: [],
  addSelection: (selection) => {
    // This is intentional
  },
  removeSelection: (index) => {
    // This is intentional
  },
});
